// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import PhotoOverlayController from "./photo_overlay_controller"
application.register("photo-overlay", PhotoOverlayController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)
import HelloController from "./hello_controller"
application.register("hello", HelloController)
import ShortNameSuggestionController from "./short_name_suggestion_controller"
application.register("short-name-suggestion", ShortNameSuggestionController)
import SliderController from "./slider_controller"
application.register("slider", SliderController)
import ThemePreviewController from "./theme_preview_controller"
application.register("theme-preview", ThemePreviewController)

import DocumentPermissionsController from "./document_permissions_controller"
application.register("document-permissions", DocumentPermissionsController)

import DocumentFilterController from "./document_filter_controller"
application.register("document-filter", DocumentFilterController)
